import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "../AxiosClient";

export const enrollUserAsync = createAsyncThunk(
  "web/enrollUser",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/enrollUser`, payload, toolkit);
  }
);

export const getUserEnrollmentAsync = createAsyncThunk(
  "admin/getUserEnrollment",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/getUserEnrollment`, [], toolkit);
  }
);

export const getAIMTSyllabusAsync = createAsyncThunk(
  "web/aimtSyllabus",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/aimtSyllabus`, payload, toolkit);
  }
);

export const getAIMTTestByIdAsync = createAsyncThunk(
  "web/getAIMTTestById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAIMTTestById?testId=${payload?.testId}`,
      payload,
      toolkit
    );
  }
);

export const getReminderAsync = createAsyncThunk(
  "web/getReminder",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/getReminder`, payload, toolkit);
  }
);

export const addReminderAsync = createAsyncThunk(
  "web/addReminder",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/addReminder`, payload, toolkit);
  }
);

export const getAIMTByUserBatchAsync = createAsyncThunk(
  "web/getAIMTTestByGoal",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAIMTTestByGoal?type=${payload?.type}&category=${
        payload?.category || ""
      }&packageId=${payload?.packageId || ""}`,
      payload,
      toolkit
    );
  }
);
